"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSelected = exports.getClassNameForCell = exports.getEvenOddClassName = void 0;

var _constants = require("./constants");

var getEvenOddClassName = function getEvenOddClassName(inputIndex) {
  return inputIndex % 2 ? _constants.enumParityClass.ODD : _constants.enumParityClass.EVEN;
};

exports.getEvenOddClassName = getEvenOddClassName;

var getClassNameForCell = function getClassNameForCell(colInGroupIndex, colGroupIndex, fullColIndex) {
  var newColGroup = colGroupIndex !== 0 && colInGroupIndex === 0;
  var colEvenOdd = getEvenOddClassName(fullColIndex);
  var colGroupEvenOdd = getEvenOddClassName(colGroupIndex);
  var colGroupChanged = newColGroup ? ' col-group-changed' : '';
  return "col-".concat(colEvenOdd, " col-group-").concat(colGroupEvenOdd).concat(colGroupChanged);
};

exports.getClassNameForCell = getClassNameForCell;

var isSelected = function isSelected(data, value) {
  return data.includes(value);
};

exports.isSelected = isSelected;
//# sourceMappingURL=utils.js.map